export default __webpack_public_path__ + "static/media/front.f50735a5.png";